import React, { useState } from "react";
import { TrackModal } from "../components/TrackModal";
import { TrackData } from "../types/Types";
import * as amplitude from "@amplitude/analytics-browser";
import "../styles/HorizontalTrackFeeds.css";

interface SongCardProps {
  track: TrackData;
}

export const SongCard = ({ track }: SongCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCardClick = () => {
    amplitude.track("track_tapped", {
      track_id: track.id,
      track_title: track.trackTitle,
      artist_name: track.artistName,
      genre: track.genreName,
      source: "horizontal_feed_card",
    });

    setIsModalOpen(true);
  };

  return (
    <>
      <div
        className="song-card-container"
        onClick={handleCardClick}
        role="button"
        tabIndex={0}
      >
        <div className="song-card-cover">
          {track.coverArtUrl ? (
            <img src={track.coverArtUrl} alt={track.trackTitle} />
          ) : (
            <div className="cover-placeholder" />
          )}
        </div>

        <div className="song-card-details">
          <h3 className="song-card-title">
            {track.trackTitle || "Unknown Title"}
          </h3>
          <p className="song-card-artist">
            {track.artistName || "Unknown Artist"}
          </p>
        </div>
      </div>

      <TrackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        track={track}
      />
    </>
  );
};
